import * as yup from 'yup';
import { CentreServiceScolaire } from '../entities';

export const schemaCentreServiceScolaire = yup.object<Partial<CentreServiceScolaire>>({
    name: yup.string().required('Ce champ est requis'),
    abbr: yup.string().nullable(),
    link: yup.string().nullable(),
    fk_id_region: yup.number().nullable(),
    email: yup.string().email('Ce champ doit contenir une adresse courriel valide').nullable(),
    num_fournisseur: yup.string().nullable(),
    notes: yup.string().nullable(),
    fk_id_lieu: yup.number().nullable(),
    fk_id_contact_par_defaut: yup.number().nullable(),
}) as yup.ObjectSchema<Partial<CentreServiceScolaire>>;
